import { styled } from '@mui/material';
import { useMemo } from 'react';
import { Numbers } from 'src/ui-components/helpers/formatters';
import { themeStyles, themeVars } from 'src/ui-components/theme/theme';

import { IconTrendDown, IconTrendUp } from '../../ui-components/icons';

interface PercentCellProps {
  value: number;
  decimal?: boolean;
  colored?: boolean;
  hideTrendIcon?: boolean;
  divide?: boolean;
}

export const PercentCell = ({
  value: _value,
  decimal,
  colored,
  hideTrendIcon,
  divide,
}: PercentCellProps) => {
  const value = divide ? Numbers.parse(_value) / 100 : _value;

  const formattedValue = useMemo(() => {
    return Numbers.formatPercents(value, { decimal });
  }, [decimal, value]);

  const color = useMemo((): Numbers.DynamicType | null => {
    if (!colored) return null;
    return Numbers.getDynamic(value);
  }, [value, colored]);

  return (
    <Root $color={color}>
      {color === 'positive' && !hideTrendIcon && <IconTrendUp size={16} />}
      {color === 'negative' && !hideTrendIcon && <IconTrendDown size={16} />}
      {formattedValue}
    </Root>
  );
};

const Root = styled('div')<{ $color: Numbers.DynamicType | null }>`
  ${themeStyles.text.ellipsis};
  ${themeStyles.text.telka.body.md};
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: flex-end;
  color: ${(p) => (p.$color ? Numbers.dynamicsColors[p.$color] : themeVars.colors.coldGrey900)};
  gap: 2px;
`;
